// extracted by mini-css-extract-plugin
export var link = "_tr-0";